"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useReorientImage = void 0;
var lodash_1 = require("lodash");
var react_1 = require("react");
var decideIfFullWidthOrFullHeightImg_1 = require("../decideIfFullWidthOrFullHeightImg");
var changeImageOrientation_1 = require("./changeImageOrientation");
var bannerContext_1 = require("../../../../../Banners/bannerContext");
var UIContent_1 = require("../../../../../../UIContent");
var useReorientImage = function (_a) {
    var imageRotate = _a.imageRotate, setFullWidthOrFullHeightImg = _a.setFullWidthOrFullHeightImg, setUnderEditImageData = _a.setUnderEditImageData, publicUrl = _a.publicUrl, aspectRatio = _a.aspectRatio, isFirstMount = _a.isFirstMount, handleDeleteSingleImage = _a.handleDeleteSingleImage, readOnly = _a.readOnly;
    var SET_ALERT_BANNER = (0, bannerContext_1.useBannerContext)().SET_ALERT_BANNER;
    var _b = (0, react_1.useState)(true), imageLazyLoading = _b[0], setImageLazyLoading = _b[1];
    var _c = (0, react_1.useState)(undefined), reorientedImageTempUrl = _c[0], setReorientedImageTempUrl = _c[1];
    (0, react_1.useEffect)(function () {
        if (!imageLazyLoading)
            setImageLazyLoading(true);
        //if image rotation = undefined / 0 / -0, set reorientedImgTemp -> undefined
        //this way the og public url will be used to render
        if (imageRotate === undefined || [0, -0].indexOf(imageRotate) !== -1) {
            if (reorientedImageTempUrl)
                setReorientedImageTempUrl(undefined);
            var img = new Image();
            img.src = publicUrl;
            img.onerror = function () {
                /**
                 * even tho we have several checks on the okf mediaupload api to
                 * ensure proper file format and such. it is still sometimes possible that
                 * an incorrect / corrupt url is being passed through as 'publicUrl' to
                 * this component. In such cases, an error will fire here, and we need to
                 * handle it, by deleting said url and throwing an alert
                 */
                if (!readOnly) { //this also fixes another issue. in readonly in some cases (LinkEmbed) on change prop is not available. handleDelete uses the onChange, so this !readOnly condition solves that problem as well
                    handleDeleteSingleImage({ publicUrl: publicUrl });
                    SET_ALERT_BANNER(UIContent_1.UIContent.ImageInput.corruptUrlErrMsg, 'red', 3000);
                }
                else {
                    setImageLazyLoading(false); // in read only, let the broken image attempt to render and browser will show some default UI for the error  
                }
            };
            img.onload = function () {
                setFullWidthOrFullHeightImg((0, decideIfFullWidthOrFullHeightImg_1.decideIfFullWidthOrFullHeightImg)({
                    imgWidth: this.width,
                    imgHeight: this.height,
                    wrapperAspectRatio: aspectRatio,
                }));
                setImageLazyLoading(false);
            };
        }
        else {
            (0, changeImageOrientation_1.changeImageOrientation)({
                srcUrl: publicUrl,
                imageRotate: imageRotate,
                callback: function (_a) {
                    //cuz its possible that this may run even if not in edit mode
                    //e.g first mount, and on 'dont save changes'
                    var reorientedUrl = _a.reorientedUrl, imageWidth = _a.imageWidth, imageHeight = _a.imageHeight;
                    setFullWidthOrFullHeightImg((0, decideIfFullWidthOrFullHeightImg_1.decideIfFullWidthOrFullHeightImg)({
                        imgWidth: imageWidth,
                        imgHeight: imageHeight,
                        wrapperAspectRatio: aspectRatio,
                    }));
                    setReorientedImageTempUrl(reorientedUrl);
                    setImageLazyLoading(false);
                    // setUrlAfterRotate(resetBase64Image);
                },
            });
        }
        /**
         * if is not first mount, then rotate just happened.
         * so reset crop data
         */
        if (!isFirstMount) {
            //means if it is in edit mode
            setUnderEditImageData(function (prev) {
                var newData = (0, lodash_1.cloneDeep)(prev);
                delete newData.cropX;
                delete newData.cropY;
                return newData;
            });
        }
    }, [imageRotate]);
    return { reorientedImageTempUrl: reorientedImageTempUrl, imageLazyLoading: imageLazyLoading };
};
exports.useReorientImage = useReorientImage;
